export const BASE_URL = process.env.VUE_APP_API_HOST || 'http://localhost:5001/';
export const IS_MZ_BRANDING = (process.env.VUE_APP_IS_MZ_BRANDING || '').toLowerCase() === 'true';
export const HAS_OAUTH_LOGIN = false; // change this to true once oauth via the gate is configured
export const SENTRY_ENV = process.env.VUE_APP_SENTRY_ENV || "DEV"
